/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPGENDER = {
    Male: 'M',
    Female: 'F'
} as const;
export type IAPGENDER = typeof IAPGENDER[keyof typeof IAPGENDER];


export function IAPGENDERFromJSON(json: any): IAPGENDER {
    return IAPGENDERFromJSONTyped(json, false);
}

export function IAPGENDERFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPGENDER {
    return json as IAPGENDER;
}

export function IAPGENDERToJSON(value?: IAPGENDER | null): any {
    return value as any;
}

